import config from "@/config"
import { post } from "../ApiService"

export const createInternalProfile = async (data: any) => {

  const url = `${config.apiHost}/internal-profiles`

  const res = await post(url, data, "CREATE_INTERNAL_PROFILE")

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const assignInternalProfile = async (body: any) => {

  const url = `${config.apiHost}/teams/assign-internal-profile`

  try {

    const res = await post(url, body, "ASSIGN_INTERNAL_PROFILE")

    if (res.error || !res.data.success) {

      throw new Error(res.error || 'Error assigning internal profile')
    }

    return [null, res.data]
  } catch (error) {

    return [error, null]
  }
}

export const unassignInternalProfile = async (body: any) => {

  const url = `${config.apiHost}/teams/unassign-internal-profile`

  try {

    const res = await post(url, body, "UNASSIGN_INTERNAL_PROFILE")

    if (res.error || !res.data.success) {

      throw new Error(res.error || 'Error unassigning internal profile')
    }

    return [null, res.data]
  } catch (error) {

    return [error, null]
  }
}
